/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Address/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Fields from './Fields/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'



/** @type {import('Simple/types.js').View} */
export default function Address({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Postal/NewAddress/Content/NewRelation/Add/Content/Address"
  
}) {
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 color={dtColorsNeutral800}
 text="Address"
/>
<Fields
  viewPath={`${viewPath}/Fields`}
/>
{children}
</React.Fragment>)
}